import type {FetchFunction} from '../fetch'

type CreatePassportMiddlewareParams = {
  host: string
}

function createPassportMiddleware(params: CreatePassportMiddlewareParams) {
  const {host} = params

  function withPassportMiddleware(fetchFn: FetchFunction): FetchFunction {
    return function passportFetch(config) {
      return fetchFn({
        ...config,
        url: `${host}${config.url}`,
        options: {
          credentials: 'include',
        },
      })
    }
  }

  return withPassportMiddleware
}

export {createPassportMiddleware}
